import { LineMark, PillMark, pillAlign } from "@/ds";

import type { GanttItem, GanttPill } from "@/shared/components/gantt-carga/gantt-rows";
import { LINE_LAYOUT, PILL_LAYOUT } from "../../gantt-fornecedor.utils";
import { SIMULACAO_MARCA_CLASSES } from "@/shared/components/simulacao-marca";
import type { GanttFornecedorBarraObraProps } from "./types-gantt-fornecedor-barra-obra";
import lineStyles from "../gantt-obra-line/gantt-obra-line.module.scss";
import styles from "../../carga-fornecedor-gantt.module.scss";

/**
 * Pílula de duração do escopo macro, na linha da obra: no início/fim da linha encosta na borda e no meio fica
 * centralizada no escopo, para nunca vazar da linha. `pill` vem em % da linha da obra (`item`), não do eixo.
 */
function DurationPill({ item, pill }: { item: GanttItem; pill: GanttPill }) {
  const start = item.left + (pill.left / 100) * item.width;
  const position = { start, end: start + (pill.width / 100) * item.width };

  return (
    <PillMark
      position={position}
      tone={item.cancelada ? "danger" : "primary"}
      past={item.past}
      layout={PILL_LAYOUT}
      lane={item.lane}
      data-align={pillAlign({ start: pill.left, end: pill.left + pill.width })}
    >
      {pill.label}
    </PillMark>
  );
}

/** Barra da obra (agrupamento por Obra): linha fina com datas e "Obra" acima e a pílula de duração. */
export function GanttFornecedorBarraObraView({ item, marca }: GanttFornecedorBarraObraProps) {
  return (
    <>
      <LineMark
        position={{ start: item.left, end: item.left + item.width }}
        tone={item.cancelada ? "danger" : "primary"}
        past={item.past}
        layout={LINE_LAYOUT}
        lane={item.lane}
        className={marca ? `${styles.lineBar} ${SIMULACAO_MARCA_CLASSES.barra}` : styles.lineBar}
        classNames={{ rule: styles.lineRule }}
        title={marca ? `${marca.texto}\n\n${item.label}` : item.label}
        data-simulado={marca ? true : undefined}
        testId={item.cancelada ? "gantt-bar-cancelada" : "gantt-bar"}
        aria-label={item.label}
        tabIndex={0}
        label={
          <span className={lineStyles.head}>
            <span>{item.start}</span>
            <span>Obra</span>
            <span>{item.end}</span>
          </span>
        }
      />
      {item.pill ? <DurationPill item={item} pill={item.pill} /> : null}
    </>
  );
}
